import { i18n } from "../translate/i18n";
import { isWhatsappApiChannel } from "./connectionChannel";

const MESSAGE_KEYS = {
  cloud_session_invalidated: "connections.sessionInvalidated.cloud",
  baileys_session_invalidated: "connections.sessionInvalidated.baileys",
};

export function resolveSessionInvalidatedToast(session) {
  if (!session?.sessionInvalidated) {
    return null;
  }

  if (session.message && i18n.exists(MESSAGE_KEYS[session.message])) {
    return i18n.t(MESSAGE_KEYS[session.message]);
  }

  const mode =
    session.reconnectMode ||
    (isWhatsappApiChannel(session.channel) ? "cloud" : "qr");

  return mode === "cloud"
    ? i18n.t("connections.sessionInvalidated.cloud")
    : i18n.t("connections.sessionInvalidated.baileys");
}
